/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { ListeContainer, useListe } from '@mairistem/liste';

import type { Specialite } from '@/types';

import SpecialiteListe from './SpecialiteListe';

interface Props {
  /** Callback appelé lors de la sauvegarde d'une ligne (liste en saisie) */
  onSave?: (qualification: Specialite) => void;
  /** Callback appelé lors de la sélection d'une ligne */
  onSelect?: (qualification: Specialite) => void;
  /** Spécialité sélectionnée */
  selectedItem?: Specialite;
  /** Réinitialisation des lignes */
  resetSelectedItem?: () => void;
}

const SpecialiteListeContainer = (props: Props) => {
  const {
    selectedItem = {},
    onSave = null,
    onSelect = null,
    resetSelectedItem = null,
  } = props;

  const [service] = useListe(
    '/api/administres/recensement-citoyen/specialites',
  );

  return (
    <ListeContainer
      service={service}
      type="specialites"
      contains="liste"
      perPage={50}
    >
      <SpecialiteListe
        onSave={onSave}
        onSelect={onSelect}
        selectedSpecialite={selectedItem}
        resetSelectedItems={resetSelectedItem}
      />
    </ListeContainer>
  );
};

export default SpecialiteListeContainer;
